import { render, staticRenderFns } from "./LineupsTable.vue?vue&type=template&id=0a241c4d&scoped=true&"
import script from "./LineupsTable.vue?vue&type=script&lang=js&"
export * from "./LineupsTable.vue?vue&type=script&lang=js&"
import style0 from "./LineupsTable.vue?vue&type=style&index=0&id=0a241c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a241c4d",
  null
  
)

export default component.exports